import "./App.css";
import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import RegisterComponent from "./components/register/RegisterComponent";
import ProfileContainerComponent from "./containers/ProfileContainerComponent";
import LandingComponent from "./components/landing/LandingComponent";
import ProtectedComponent from "./components/auth/ProtectedComponent";
import RegisterSuccessComponent from "./components/register/RegisterSuccessComponent";
import Layout from "./containers/Layout";
import RegisterLayout from "./containers/RegisterLayout";
import DetailsComponent from "./components/profile/DetailsComponent";
import VirtualAvatarComponent from "./components/profile/VirtualAvatarComponent";

class App extends Component {
  render(): React.ReactNode {
    return (
      <Routes>
        <Route path="/" element={<LandingComponent />} />
        <Route
          path="/user/register/success"
          element={<RegisterSuccessComponent />}
        />

        {/* Register route with RegisterLayout */}
        <Route path="/user/register" element={<RegisterLayout />}>
          <Route index element={<RegisterComponent />} />
        </Route>

        <Route
          path="/user/profile"
          element={<ProtectedComponent component={Layout} />}
        >
          <Route element={<ProfileContainerComponent />}>
            <Route index element={<DetailsComponent />} />
            <Route path="virtual-avatar" element={<VirtualAvatarComponent />} />
          </Route>
        </Route>
      </Routes>
    );
  }
}

export default App;
